module.exports = __webpack_public_path__ + "img/shopify004.4c309e53.png";